<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
    <section class="py-12 sm:py-24 relative">
        <NuxtImg src="/images/home-page/text-illustration-1.svg" alt="Illustracija" class="w-[75px] md:w-[100px] lg:w-[221px] h-auto absolute -top-16 lg:-top-24 right-0" />
        <NuxtImg src="/images/home-page/text-illustration-2.svg" alt="Illustracija" class="w-[200px] lg:w-[300px] h-auto absolute top-8 lg:top-[25%] -left-[100px] sm:-left-0 lg:-translate-y-1/2" />
        <UContainer>
            <div class="grid grid-cols-2 gap-12 sm:gap-24 max-w-[1000px] mx-auto items-center justify-around">
                <div class="col-span-2 sm:col-span-1">
                    <NuxtImg src="/images/home-page/text-first.webp" :alt="t('home.text.title1')" class="w-full" loading="lazy" />
                </div>
                <div class="col-span-2 sm:col-span-1 flex flex-col gap-4.5">
                    <h2 class="uppercase text-[30px] leading-[38px] sm:text-[36px] sm:leading-[46px]">{{ t("home.text.title1") }}</h2>
                    <p class="mb-4" v-html="t('home.text.description1_1')"></p>
                    <p v-html="t('home.text.description1_2')"></p>
                </div>
                <div class="col-span-2 sm:order-3 home-text-cloud-top bg-[#FDF0E499] flex justify-center items-center py-4 px-8 lg:px-24 max-w-[800px] mx-auto">
                    <p class="text-center font-bold text-[#C46B27] text-[14px] leading-[21px] sm:text-[26px] sm:leading-[36px]">{{ t("home.text.cloud1") }}</p>
                </div>
                <div class="col-span-2 sm:col-span-1 sm:order-5">
                    <NuxtImg src="/images/home-page/text-second.webp" :alt="t('home.text.title2')" class="w-full" loading="lazy" />
                </div>
                <div class="col-span-2 sm:col-span-1 flex flex-col gap-4.5 sm:order-4">
                    <h2 class="uppercase text-[30px] leading-[38px] sm:text-[36px] sm:leading-[46px]">{{ t("home.text.title2") }}</h2>
                    <p class="mb-4" v-html="t('home.text.description2_1')"></p>
                    <p class="mb-4" v-html="t('home.text.description2_2')"></p>
                    <p v-html="t('home.text.description2_3')"></p>
                </div>
                <div class="col-span-2 sm:order-6 home-text-cloud-bottom bg-[#FDF0E499] flex justify-center items-center py-4 px-8 lg:px-24 max-w-[800px] mx-auto">
                    <p class="text-center font-bold text-[#C46B27] text-[14px] leading-[21px] sm:text-[26px] sm:leading-[36px]">{{ t("home.text.cloud2") }}</p>
                </div>
            </div>
        </UContainer>
        <svg width="0" height="0" style="position:absolute">
            <defs>
                <clipPath id="home-texts-bg-cloud-top" clipPathUnits="objectBoundingBox">
                    <path d="M0.0786 0 L0.9207 0 C0.9683 0 1 0.1465 0.9986 0.311 L0.981 0.7625 C0.9755 0.8985 0.9429 1 0.9036 1 L0.1187 1 C0.0843 1 0.0539 0.9213 0.0437 0.8075 L0.0036 0.3555 C-0.0121 0.1791 0.0256 0 0.0786 0 Z" />
                </clipPath>
            </defs>
        </svg>
        <svg width="0" height="0" style="position:absolute">
            <defs>
                <clipPath id="home-texts-bg-cloud-bottom" clipPathUnits="objectBoundingBox">
                    <path d="M0.92110 1 L0.07861 1 C0.03095 1 -0.00575 0.85062 0.00075 0.68302 L0.01788 0.24096 C0.02323 0.10287 0.05647 0 0.09574 0 L0.88173 0 C0.91602 0 0.94635 0.07887 0.95668 0.19490 L0.99604 0.63696 C1.01205 0.81678 0.97423 1 0.92110 1 Z" />
                </clipPath>
            </defs>
        </svg>
    </section>
</template>

<style scoped>
.home-text-cloud-top {
    aspect-ratio: 3;
    clip-path: url(#home-texts-bg-cloud-top);
}
.home-text-cloud-bottom {
    aspect-ratio: 3;
    clip-path: url(#home-texts-bg-cloud-bottom);
}
</style>
